var map = {
	"./arrowDown.svg": 15374,
	"./arrowUp.svg": 44581,
	"./check.svg": 64817,
	"./dot.svg": 59932,
	"./frame.svg": 90398,
	"./leftArrow.svg": 29143,
	"./uberBlue.svg": 70127,
	"./uberDiamond.svg": 30269,
	"./uberGold.svg": 9737,
	"./uberPlatinum.svg": 17255
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 698;